/*Ce fichier n'est présent qu'une unique fois sur la page quelque soit le nombre de control_dynatree d'inclus*/

var global_selectFiredFromCode = false;//utilisé par les events qui fire l'event par le code


function control_quanta_tree(asp) {
    asp.hidePopupOnNextDllClick = false;
    asp.changeMade = false;//on track s'il y a eu changement de sélection pour fire ou non un postback
    asp.add_load_fired = false;
    asp.dynatreeChildrenProperty = null;

    var json = $("#" + asp.hidJson).val();//contient l'arbre à charger
    if (json != "" && json != "[]") {
        LoadJson(asp, json);

        //Si chkAll unchecked et que tout est selected, unselectAll
        var chkSelectAllState = $("#" + asp.chkSelectAll).prop('checked');
        var allNodesSelected = NodesAndChildrenAreSelected(asp.dynatreeChildrenProperty)

        if (!chkSelectAllState && allNodesSelected && asp.selectAllNodesIfNoneSelected) {
            UnSelectAllNodes(asp, asp.dynatreeChildrenProperty);
        }


        //Créer le dynatree avec les options; voir doc : http://wwwendt.de/tech/dynatree/doc/dynatree-doc.html
        $("#" + asp.divDynatree).dynatree({
            children: asp.dynatreeChildrenProperty,      //liste des éléments de l'arbre
            persist: false,                              //état save avec cookie
            checkbox: true,                              //afficher checkboxes
            selectMode: asp.selectMode,                  // 1:single, 2:multi, 3:multi-hier
            debugLevel: 0,                               //pas de sotie console
            fx: { height: "toggle", duration: 200 },     //type d'animation et durée
            onPostInit: function (isReloading, isError) {//après initialisation
                onPostInitEvent(asp);
            },
            onSelect: function (flag, node) {   //event quand checked ou unchecked
                if (asp.treeForReporting) return;
                onSelectEvent(asp, node);
            },
            onClick: function (node, event) {
                if (asp.treeForReporting) return;
                onClickEvent(asp, node, event);
            },
            onCreate: function (node, nodeSpan) {
                if (asp.treeForReporting && node.data.key != "") {
                    $(nodeSpan).attr("data-module", node.data.key);
                }

            },
            onRender: function (node, nodeSpan) {
                if (asp.isDraggable && !node.hasChildren()) {
                    var dragTarget = $(nodeSpan).parent("li");
                    dragTarget.addClass("draggableDynatreeItem");
                    dragTarget.attr("data-itemkey", node.data.key);
                    dragTarget.attr("data-itemvalue", node.data.title);

                    dragTarget.draggable({
                        addClasses: false,
                        connectToSortable: '.sortableList',
                        helper: function () {
                            //return $(this).clone().wrapAll("li").addClass("draggableItemMoving");
                            return $('<li class="draggableDynatreeItem draggableItemMoving label_larger">' + node.data.title + '</li>');
                        },
                        appendTo: 'body',
                        start: function () {
                            $(".itemsDropZoneWrapper").addClass("drawingPanel_drop_active");
                        },
                        stop: function () {
                            $(".itemsDropZoneWrapper").removeClass("drawingPanel_drop_active drawingPanel_drop_hover");
                        }
                    }).disableSelection();
                }
            }
        });

        RemakeJson(asp);
    }
    else {
        var error = asp.noneSelectedText;
        $("#" + asp.ddlDynatree + " option:first").text(error);//dropdown
        $("#" + asp.lblSelectionValue).text(error);//label
    }

    //La popup n'est accessible seulement dans cet event, qui fire après cette fonction
    //L'enregistrement de cet event n'est pas clear par les update
    Sys.Application.add_load(function (sender, arg) {
        //if (asp.add_load_fired || arg._isPartialLoad) return;//deja fired ou partial
        if (asp.add_load_fired) return;
        asp.add_load_fired = true;

        var pce = $find(asp.popupExtenderID);
        if (pce != null) {

            if (asp.isAlwaysOpen) {
                pce.show();
            } else {
                pce.add_hidden(function () {
                    //console.log("add_hidden");
                    asp.hidePopupOnNextDllClick = false;
                    validate(asp);
                });

                //drop down
                $("#" + asp.ddlDynatree).click(function () {
                    //console.log("click");
                    //popup panel
                    if (asp.hidePopupOnNextDllClick) {
                        pce.hidePopup();//fire add_hidden
                    } else {//on vient d'ouvrir la popup, on la masque on prochain click
                        asp.hidePopupOnNextDllClick = true;
                        //focus pour afficher par dessus la dropdown
                        //setTimeout(function () { $("#" + asp.pnlMain).focus(); }, 0);

                    }
                });

                //Bouton valider
                $("#" + asp.hypValider).click(function () {
                    pce.hidePopup();//fire add_hidden
                });
            }
        }


        if ( $("#" + asp.searchInput).val() ) {
            SearchChanged({ data: asp });
        }
    });

    //Add bouton de validation du filtre
    if (!asp.bFiltreAuto) {
        //un peu de place
        $("#" + asp.updMain).find(".inputFiltre").css("width", "80%");

        //show
        $("#" + asp.updMain).find(".btnValidateFiltre").css("display", "inline-block");

        //click event
        $("#" + asp.updMain).find(".btnValidateFiltre").click(function (evt) {
            evt.preventDefault(); //pas de validation de form, merci
            Search(asp)();
        });
    }
    else {
        //Applique le filtre on changement d'input
        $("#" + asp.searchInput).on('keyup', asp, SearchChanged);
    }
    

    //Tout sélectionner
    $("#" + asp.chkSelectAll).change(function () {
        ChkSelectAllChanged(asp);
    });

    //Ne pas ouvrir dropdown au click
    $("#" + asp.ddlDynatree).mousedown(function () {
        return false;
    });

    //Tooltip old
    $("#" + asp.ddlDynatree).mouseover(function () {
        var tooltipVal = $("#" + asp.ddlDynatree + " option:first").text();
        Tip(tooltipVal, BGCOLOR, '#F7F7F7', FONTCOLOR, '#000000');
    });

    //Tooltip Bootstrap
    //$("#" + asp.ddlDynatree).tooltip({
    //    placement : "auto top",
    //    trigger : "focus"
    //});
}

function onPostInitEvent(asp) {
    //On parcourt l'arbre
    var tree = $("#" + asp.divDynatree).dynatree("getTree");
    globalAsp = asp;//argument pour tree.visit()
    tree.visit(TreeVisitPostInit, false);
    tree.redraw();//car on a modifié la property node.data.addClass dans TreeVisit 

    ////Draggable
    ////if (asp.isDraggable) {

    ////    $(".draggableDynatreeItem").draggable({
    ////        addClasses: false,
    ////        connectToSortable: '.sortableList',
    ////        helper: function () {
    ////            return $(this).clone().addClass("draggableItemMoving");
    ////        },
    ////        appendTo: 'body'
    ////    }).disableSelection();
    ////}
}

function onSelectEvent(asp, node) {
    //node.select() ne fire pas l'event sur les enfants

    asp.changeMade = true;//autorise les postback

    if (global_selectFiredFromCode) return;//On ignore les select fired par le code
    //console.log(node.data.title);

    AllVisibleAndSelectableNodesSelected(asp);//met à jour asp.allVisibleAndSelectableNodesSelected et l'ui

    //Update json field
    RemakeJson(asp);
}

function validate(asp) {
    if (asp.autoPostback && asp.changeMade) SelectedChangedPostback(asp);
}

function ChkSelectAllChanged(asp) {
    //Si on décoche, on décoche tout les nodes
    //Si on coche, on coche seulement les nodes visibles (et feuilles non visibles si mode MultiHier(3))


    //On parcourt l'arbre
    global_selectFiredFromCode = true;
    asp.chkSelectAllState = $("#" + asp.chkSelectAll).prop('checked');
    globalAsp = asp;//argument pour tree.visit()
    var tree = $("#" + asp.divDynatree).dynatree("getTree");
    tree.visit(TreeVisitChkSelectAllChanged, false);
    tree.redraw();
    global_selectFiredFromCode = false;

    //Update json field
    RemakeJson(asp);
}

//effectue un postback serveur quand la sélection a été modifiée
//Fire l'event quand l'user ferme le panel
function SelectedChangedPostback(asp) {
    //console.log("__doPostBack");
    //On passe en arg1 le client id de l'update panel, et en arg2 le client id du control originant le postback
    __doPostBack(asp.updMain, asp.myClientId);
}

function onClickEvent(asp, node, event) {
    //Clic sur un label
    if (node.getEventTargetType(event) == "title") {
        if (node.getChildren() != null) { //Si enfants : expand/collapse
            node.toggleExpand();
        } else {//Si c'est une feuille select/unselect
            node.toggleSelect();
        }
        return false;
    }
}

//Vrai si tous les nodes visibles and seletable sont checked
//Résultat dans asp.allVisibleAndSelectableNodesSelected
function AllVisibleAndSelectableNodesSelected(asp) {
    //On ne fait rien si le control et disabled
    if (!asp.enabled) return;

    asp.allNodesSelected = true;//on met à true et on parcourt jusqu'à en trouver un unselected
    globalAsp = asp;//argument pour tree.visit()
    var tree = $("#" + asp.divDynatree).dynatree("getTree");
    tree.visit(TreeVisitInspectSelection, false);
    tree.redraw();
    $("#" + asp.chkSelectAll).attr('checked', asp.allNodesSelected);//update ui
}

function TreeVisitInspectSelection(node) {
    var asp = globalAsp;

    if (!node.data.unselectable && !node.isSelected() && !hasClassNode(node, "hiddenNode")) {
        asp.allNodesSelected = false;
        return false;//on arrete le parcourt
    }
}

function TreeVisitChkSelectAllChanged(node) {
    var asp = globalAsp;//set avant l'appel à tree.visit()

    if (!asp.chkSelectAllState) {//Si on décoche, on décoche tout les nodes
        node.select(false);
    } else {//Si on coche, on coche seulement les nodes visibles (il peuvent ne pas avoir la classe displayedNode)
        if (!hasClassNode(node, "hiddenNode")) {
            if (asp.selectMode == 2 || !node.hasChildren())//feuilles si mode MultiHier(3) ou pas d'enfants
                node.select(true);
        }
            
    }
}

function TreeVisitPostInit(node) {
    var asp = globalAsp;//set avant l'appel à tree.visit()

    AddOrRemoveDisabledStatus(node);
    
    if (asp.treeForReporting) {
        node.expand(true);

        if (node.data.key != "") {
            addClassNode(node, "moduleItem2");
            addClassNode(node, "draggableItem2");
            node.data.tooltip = node.data.key;
        }
        //node.toggleExpand();
    }

    if (asp.startExpanded) {
        node.expand(true);
    }
}

function AddOrRemoveDisabledStatus(node) {
    //Application des classes disabled
    if (node.data.unselectable) {//node disabled
        addClassNode(node, "disabled");

        if (node.isSelected()) {//node selected
            addClassNode(node, "disabledChecked");

            //set parents as partial disabled
            node.visitParents(function (parent) {
                if(parent.data.unselectable)
                    addClassNode(parent, "disabledPartial");
            }, false);
        }
        else {//node unselected
            addClassNode(node, "disabledUnchecked");
        }
    }
    else {//node enabled
        removeClassNode(node, "disabled");
        removeClassNode(node, "disabledUnchecked");
        removeClassNode(node, "disabledChecked");
        removeClassNode(node, "disabledPartial");
    }
}

//#region Recherche
var globalAsp;//variable utilisée pour passage d'argument à tree.visit()


var timeoutID = null;
function SearchChanged(evt) {
    var asp = evt.data;//passé en argument

    if (timeoutID != null) clearTimeout(timeoutID);
    var timeoutID = setTimeout(Search(asp), asp.intervalSearch)
}

function Search(asp) {

    return function () {
        var tree = $("#" + asp.divDynatree).dynatree("getTree");
        var searchValue = $("#" + asp.searchInput).val().toLowerCase();

        //On parcourt l'arbre
        asp.searchValue = searchValue;
        globalAsp = asp;//argument pour tree.visit()
        var tree = $("#" + asp.divDynatree).dynatree("getTree");
        tree.visit(TreeVisitSearchChanged, false);
        tree.redraw();//car on a modifié la property node.data.addClass dans TreeVisit

        AllVisibleAndSelectableNodesSelected(asp);//met à jour asp.allVisibleAndSelectableNodesSelected et l'ui
    };
}

function TreeVisitSearchChanged(node) {
    var asp = globalAsp;//set avant l'appel à tree.visit()

    if (asp.searchValue != "") {
        //Expand tous les nodes
        node.expand(true);

        //On masque tous les nodes
        removeClassNode(node, "displayedNode");
        addClassNode(node, "hiddenNode");

        //On display les matched nodes et leur parents
        if (matchesSearch(node, asp.searchValue)) {
            removeClassNode(node, "hiddenNode");
            addClassNode(node, "displayedNode");

            visitParents(node, function (node) {
                removeClassNode(node, "hiddenNode");
                addClassNode(node, "displayedNode");
            });
        }
    }
    else {
        //Recherche vide, collapse et display all
        node.expand(false);
        removeClassNode(node, "hiddenNode");
        addClassNode(node, "displayedNode");
    }
}

//Retourne vrai si le node match la recherche
//Vrai si champ de recherche vide
function matchesSearch(node, searchString) {

    if (searchString.trim() == "") return true;
    var words = searchString.split(" ");
    return containsAllWords(node.data.title.toLowerCase(), words)
}

//retourne vrai si stringToSearchIn contient toutes les chaines de stringArray
function containsAllWords(stringToSearchIn, stringArray) {
    for (var i = 0; i < stringArray.length; i++) {
        if (stringToSearchIn.indexOf(stringArray[i]) < 0)
            return false;
    }

    return true;
}
//#endregion

//#region Utilitaire

//Déselection tous les noeuds de l'objet json
function UnSelectAllNodes(asp, nodeArrayObj) {
    if (typeof (nodeArrayObj) === "undefined") return;

    for (var i = 0; i < nodeArrayObj.length; i++) {
        nodeArrayObj[i].select = false;

        if (typeof (nodeArrayObj[i].children) !== "undefined" && nodeArrayObj[i].children !== null && nodeArrayObj[i].children.length > 0)
            UnSelectAllNodes(asp, nodeArrayObj[i].children);
    }
}

//Vrai si tous les noeuds sont selected ou pas de noeuds
function NodesAndChildrenAreSelected(nodeArrayObj) {
    if (typeof (nodeArrayObj) == "undefined") return true;

    for (var i = 0; i < nodeArrayObj.length; i++) {
        if (!nodeArrayObj[i].select)
            return false;

        if (!NodesAndChildrenAreSelected(nodeArrayObj[i].children))
            return false;
    }

    return true;
}

function visitParents(node, callback) {
    if (node == null) return;

    var parent = node.getParent();
    if (parent != null) {
        callback(node);
        visitParents(parent, callback);
    }
}

function hasClassNode(node, className) {
    return (node.data.addClass.indexOf(className) >= 0);
}

function addClassNode(node, className) {
    if (node.data.addClass == null) node.data.addClass = "";
    if (!hasClassNode(node, className)) node.data.addClass = node.data.addClass.trim() + " " + className;
}

function removeClassNode(node, className) {
    if (node.data.addClass == null) node.data.addClass = "";
    if (hasClassNode(node, className)) node.data.addClass = node.data.addClass.replace(className, "").trim();
}

function AllChildrenCheckedOrNoChildren(node){
    var result = true;
    var children = node.getChildren();

    if (children == null){//pas d'enfants
        result = true;
    }else{
        for (var i = 0; i < children.length; i++) {
            if (!children[i].isSelected()){
                result= false;
                break;
            }
        }
    }

    return result;
}
//#endregion

//#region Json
function LoadJson(asp, json) {
    try{
        asp.dynatreeChildrenProperty = JSON.parse(json);
        //console.log(asp.dynatreeChildrenProperty);
        SetIconProperty(asp.dynatreeChildrenProperty, false);//ajoute une property icon à false
        SetUnselectedTooltipProperty(asp.dynatreeChildrenProperty, asp.tooltipOnUnselectableNodes);//ajoute une property tooltip
    } catch (e) {
        asp.dynatreeChildrenProperty = [];
    }
}

function SetIconProperty(arrayOfChildren, value) {
    for (var i = 0; i < arrayOfChildren.length; i++) {
        arrayOfChildren[i].icon = value;
        if (arrayOfChildren[i].children != null)
            SetIconProperty(arrayOfChildren[i].children, value);
    }
}

function SetUnselectedTooltipProperty(arrayOfChildren, value) {
    if (value.trim() == "") return;

    for (var i = 0; i < arrayOfChildren.length; i++) {
        if (arrayOfChildren[i].unselectable)
            arrayOfChildren[i].tooltip = value;

        if (arrayOfChildren[i].children != null)
            SetUnselectedTooltipProperty(arrayOfChildren[i].children, value);
    }
}

//Appellé à chaque fois que l'état du tree change (en particulier la sélection)
function RemakeJson(asp) {
    var dynObj = $("#" + asp.divDynatree);
    if (dynObj.length == 0) return;

    var tree = dynObj.dynatree("getTree");
    var dynatreeToJsObj = ConvertNodesToObjArray(asp, tree.getRoot().getChildren());
    //console.log(dynatreeToJsObj);

    $("#" + asp.hidJson).val(JSON.stringify(dynatreeToJsObj)).change();
    UpdateSelectionString(asp);
}

function ConvertNodeToObj(asp, node) {
    var obj = {
        key: node.data.key,
        title: node.data.title,
        select: node.isSelected(),
        unselectable: node.data.unselectable,
        hideCheckbox: node.data.hideCheckbox,
        children: ConvertNodesToObjArray(asp, node.getChildren())
    };

    //Delete property ayant leur valeur par defaut pour optimiser la taille du field dans la page
    if (!obj.unselectable) delete obj.unselectable;
    if (!obj.hideCheckbox) delete obj.hideCheckbox;
    if (obj.children.length == 0) delete obj.children;

    return obj;
}

function ConvertNodesToObjArray(asp, nodes) {
    var nodesObjArray = [];

    if (nodes != null) {
        for (var i = 0; i < nodes.length; i++)
            nodesObjArray.push(ConvertNodeToObj(asp, nodes[i]));
    }
    return nodesObjArray;
}
//#endregion

//#region Selection String
function UpdateSelectionString(asp) {

    asp.selectionString = "";
    asp.allNodesUnselected = true;//update par TreeVisitUpdateSelectionString
    asp.allNodesSelected = true;//update par TreeVisitUpdateSelectionString
    globalAsp = asp;//argument pour tree.visit()
    var tree = $("#" + asp.divDynatree).dynatree("getTree");
    tree.visit(TreeVisitUpdateSelectionString, false);
    tree.redraw();

    //Si tout est déselectionné et que le mode est selectAllNodesIfNoneSelected
    if (asp.selectAllNodesIfNoneSelected && asp.allNodesUnselected) {
        asp.selectionString = "";

        //on select tout les parents
        var parentNodes = tree.getRoot().getChildren();
        if (parentNodes != null) {
            for (var i = 0; i < parentNodes.length; i++) {
                asp.selectionString += parentNodes[i].data.title + "; ";
            }
        }
    }

    //Si on doit replacer par "Tout"
    if (asp.replaceAllSelectedWithText && (asp.allNodesSelected || (asp.selectAllNodesIfNoneSelected && asp.allNodesUnselected))) {
        asp.selectionString = asp.allSelectedText;
    }

    //Si rien n'est select et que l'on remplace pas "rien par tout"
    if (!asp.selectAllNodesIfNoneSelected && asp.allNodesUnselected) {
        asp.selectionString = asp.noneSelectedText;
    }


    //Supprime dernier séparateur
    if (asp.selectionString.indexOf("; ") > 0)
        asp.selectionString = asp.selectionString.substr(0, asp.selectionString.lastIndexOf("; "));

    //Max chars
    var maxCaracters = 200;
    if (asp.selectionString.length >= maxCaracters)
        asp.selectionString = asp.selectionString.substr(0, maxCaracters) + "...";


    $("#" + asp.ddlDynatree + " option:first").text(asp.selectionString);//dropdown
    $("#" + asp.lblSelectionValue).text(asp.selectionString);//label
    $("#" + asp.ddlDynatree).attr("title", asp.selectionString);//tooltip
}

function TreeVisitUpdateSelectionString(node) {
    var asp = globalAsp;

    var parent = node.getParent();
    //le node "root" est non null mais sa valeur data.title est null

    //Update asp.allNodesUnselected
    if (node.isSelected()) asp.allNodesUnselected = false;

    //Update asp.allNodesSelected
    if (!node.isSelected()) asp.allNodesSelected = false;

    if (!asp.factorizeSelection) {
        //C'est le mode "normal" : on affiche chaque noeud sélectionné

        if (node != null && node.isSelected())
            asp.selectionString += node.data.title + "; ";
    }
    else {
        //Mode "factorisé" : Si tous les fils d'un parent checked alors on les replace par ce parent

        //Skip si null, ou non selected, ou parent selected
        if (node == null || !node.isSelected() || (parent != null && parent.data.title != null && parent.isSelected())) {
        }
        else {
            //ajouter si tous les enfants selected ou pas d'enfants
            if (AllChildrenCheckedOrNoChildren(node)) {
                asp.selectionString += node.data.title + "; ";
            }
        }
    }
    
}
//#endregion